import React, { useState } from 'react';

import styled from '@emotion/styled';

import { Menu, MenuDropdown } from '@Calix-Commerce/design-system/components';
import userAvatarSrc from 'assets/images/representative.jpg';

import { InfoBlock } from './InfoBlock';

const MenuStyled = styled(Menu)`
  .MuiButton-label {
    flex-direction: row;
    align-items: stretch;
  }
`;

const Title = styled.div`
  width: 155px;
  font-size: 1rem;
  margin-bottom: 0.2rem;
  font-weight: bold;
`;

const PictureWrapper = styled.div`
  width: 60px;
  height: 60px;
  margin-right: 0.75rem;

  img {
    width: 100%;
    border: 1px solid #808080;
  }
`;

const ContactSupport = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  return (
    <MenuStyled
      isOpen={isDropdownOpen}
      onClick={() => (isDropdownOpen ? closeDropdown() : setIsDropdownOpen(true))}
      onClickOutside={closeDropdown}
    >
      <PictureWrapper>
        <img src={userAvatarSrc} alt="RMA Support" />
      </PictureWrapper>
      <Title>Contact RMA Support</Title>
      <MenuDropdown isOpen={isDropdownOpen}>
        <InfoBlock />
      </MenuDropdown>
    </MenuStyled>
  );
};
export { ContactSupport };
